<template>
  <div class="choose-board container">
    <div class="panel">
      <h3>Board</h3>
      <div class="field">
        <span class="label">
          name:
        </span>
        <input type="text" v-model="name">
      </div>
      <div class="field">
        <span class="label">
          password:
        </span>
        <input type="password" v-model="password">
      </div>
      <hr>
      <h3>User</h3>
      <div class="field">
        <span class="label">
          your name:
        </span>
        <input type="text" v-model="userName">
      </div>
      <div class="submit">
        <button @click="enter">Enter</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: localStorage.getItem('lastName') || '',
      password: localStorage.getItem('password') || '',
      userName: localStorage.getItem('userName') || ''
    }
  },
  methods: {
    enter() {
      const name = this.name.toLowerCase();

      if (name === '' || this.password === '' || this.userName === '') return;

      localStorage.setItem(`${name}_password`, this.password);
      localStorage.setItem('lastName', name);
      localStorage.setItem('userName', this.userName);

      this.$router.push(`/${name}`)
    }
  }
}
</script>

<style scoped>

html {
  height: 100vh;
}

.submit {
  padding: 30px 0 30px 0;
}

</style>



// WEBPACK FOOTER //
// src/components/ChooseBoard.vue